var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card-content",
    [
      _c(
        "w-row",
        [
          _c("w-col", { attrs: { xs: "12", md: "6" } }, [
            _vm._v(" Doel dossier kiezen "),
          ]),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12", md: "6" } },
            [
              _c("app-dossier-search", {
                attrs: { value: _vm.targetDossier, label: "Dossier zoeken" },
                on: {
                  input: function ($event) {
                    return _vm.setDossier($event)
                  },
                },
              }),
              _c(
                "w-link",
                {
                  on: {
                    click: function ($event) {
                      _vm.createCompanyOpen = true
                    },
                  },
                },
                [
                  _c("w-fa", { attrs: { icon: "plus" } }),
                  _vm._v(" Nieuw dossier aanmaken"),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.createCompanyOpen
        ? _c(
            "w-modal",
            { attrs: { value: "" } },
            [
              _c("app-company-create-card", {
                attrs: {
                  "max-width": "1100",
                  "show-cancel-button": "",
                  "default-db-id": _vm.defaultTargetDbId,
                },
                on: {
                  "company-id": _vm.onCompanyCreated,
                  cancel: function ($event) {
                    _vm.createCompanyOpen = false
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }